import type React from 'react';
import styled from 'styled-components';
import { FlexRow } from '../../row/FlexRow.tsx';

const StyledFlexRow = styled(FlexRow)`
  min-height: 54px;
`;

export interface IFullscreenHeaderRowProps {
  logo: React.ReactNode;
  main?: React.ReactNode;
  right?: React.ReactNode;
  isMobile?: boolean | null;
}

/**
 * Riga dell'header del layout fullscreen: logo, menu principale, menu destro.
 * In mobile il menu principale è nascosto (resta raggiungibile dal menu destro).
 */
export function FullscreenHeaderRow(props: IFullscreenHeaderRowProps) {
  const { logo, main, right, isMobile } = props;

  return (
    <StyledFlexRow gutter={32} left={logo} right={right}>
      {!isMobile && main}
    </StyledFlexRow>
  );
}
